import { useQuery } from "@tanstack/react-query";
import {
  AccountTeamMembersClient,
  GetCustomerFacingYourShiTeamResponse,
} from "@lib/ShiOneClient";
import { useApi } from "@utils/useApi";

export const useGetYourShiTeam = () => {
  const api = useApi(AccountTeamMembersClient);
  const getYourShiTeam = async () => {
    return await api.getYourShiTeam();
  };
  return useQuery<GetCustomerFacingYourShiTeamResponse, Error>({
    queryKey: ["business-review-your-shi-team"],
    queryFn: getYourShiTeam,
  });
};
